/* Lemyn Coins — v2 (12 Oct 2026).
   Joe: the cart is the wrong place to spend Coins; the customer chooses at the very last step.
   Coins are now used AT CHECKOUT (our checkout box + the "Lemyn Coins" discount, app "Lemyn Coins").
   The cart only says what the order earns and how many Coins the customer has to use at checkout.
   Rules: 1 Coin per $1 spent · 100 Coins = $5 · Coins leave the balance only when the order is paid.
   Old v1 cart codes (COINS-XXXX) still left open from before are cancelled on sight, so nothing doubles. */
(function(){
var API='https://o3zbhndodykhofnap5wirbh4340rkhbc.lambda-url.us-east-1.on.aws', PER=100, VAL=5;
var ME=window.LEMYN_ME||null, S={loaded:false,bal:0,worth:0};
function post(p,o){ return fetch(API+p,{method:'POST',headers:{'content-type':'application/json'},body:JSON.stringify(Object.assign({id:ME.id,ts:ME.ts,sig:ME.sig},o||{}))}).then(function(r){return r.json();}).catch(function(){return null;}); }
function money(n){ return '$'+(n%1?n.toFixed(2):n.toFixed(0)); }
function fmt(n){ return Number(n).toLocaleString('en-US'); }
function parse(t){ var m=String(t||'').replace(/,/g,'').match(/\$\s*([0-9]+(?:\.[0-9]+)?)/); return m?parseFloat(m[1]):0; }
function loginUrl(){ return '/customer_authentication/login?return_to='+encodeURIComponent(location.pathname+location.search); }
window.LemynCoins={ balance:function(){return S.bal;}, worth:function(){return S.worth;}, open:function(){return null;},
  rules:'1 Lemyn Coin for every $1 spent; 100 Coins = $5 off; when logged in you choose how many to use at checkout, under the discount code; Coins expire after 12 months without an order; wholesale accounts do not earn.' };

var css=document.createElement('style');
css.textContent='.lc-coins{margin:12px 0 0;padding:12px 14px;border-radius:14px;background:#FFF6E2;border:1px solid #F1DDAE;font-size:14.5px;line-height:1.4;color:#191713}'
+'.lc-coins b{font-weight:800}.lc-coins .c1{display:flex;align-items:center;gap:8px}'
+'.lc-coins .dot{width:22px;height:22px;flex:none;border-radius:50%;background:radial-gradient(circle at 35% 30%,#FFE58A,#F2B807 60%,#C98F00);box-shadow:inset 0 -2px 0 rgba(0,0,0,.12);display:grid;place-items:center;font:800 11px/1 system-ui;color:#7a5600}'
+'.lc-coins .c2{display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;gap:8px;margin-top:9px;padding-top:9px;border-top:1px dashed #E9CF94}'
+'.lc-coins a{color:#B93A1A;font-weight:800}'
+'.lc-earn{display:flex;align-items:center;gap:6px;margin:6px 0 0;font-size:13px;font-weight:700;color:#9a6b00}.lc-earn .dot{width:16px;height:16px;flex:none;border-radius:50%;background:radial-gradient(circle at 35% 30%,#FFE58A,#F2B807 60%,#C98F00);display:grid;place-items:center;font:800 9px/1 system-ui;color:#7a5600}';
document.head.appendChild(css);

var targets=[];
function paint(t){
  var total=parse(t.el.textContent), box=t.box;
  if(!total){ box.style.display='none'; return; }
  box.style.display='';
  var h='<div class="c1"><span class="dot">L</span><span>This order earns <b>'+fmt(Math.floor(total))+' Lemyn Coins</b>.</span></div>';
  if(!ME){
    h+='<div class="c2"><span>Have Coins? <a href="'+loginUrl()+'">Log in</a> and use them at checkout.</span></div>';
  } else if(S.loaded && S.bal>=PER){
    h+='<div class="c2"><span>You have <b>'+fmt(S.bal)+' Coins</b>, worth <b>'+money(S.worth)+'</b>. Choose how many to use at checkout.</span></div>';
  } else if(S.loaded && S.bal>0){
    h+='<div class="c2"><span>You have <b>'+fmt(S.bal)+' Coins</b>. At 100 Coins you get $5 off.</span></div>';
  }
  box.innerHTML=h;
}
function paintAll(){ targets.forEach(paint); }
function hook(id){
  var el=document.getElementById(id); if(!el) return;
  var box=document.createElement('div'); box.className='lc-coins';
  var row=el.parentNode.parentNode; row.parentNode.insertBefore(box, row.nextSibling);
  var t={el:el,box:box}; targets.push(t);
  new MutationObserver(function(){ paint(t); }).observe(el,{childList:true,characterData:true,subtree:true});
  paint(t);
}
function hookEarn(id){
  var el=document.getElementById(id); if(!el) return;
  var host=(id==='pBig')?el.parentNode:el;
  var e=document.createElement('div'); e.className='lc-earn';
  host.parentNode.insertBefore(e, host.nextSibling);
  var draw=function(){ var v=parse(el.textContent); if(!v){ e.style.display='none'; return; } e.style.display=''; e.innerHTML='<span class="dot">L</span>Earn '+fmt(Math.floor(v))+' Lemyn Coins'; };
  new MutationObserver(draw).observe(el,{childList:true,characterData:true,subtree:true}); draw();
}
function mount(){
  ['bTotal','tot'].forEach(hook); ['rPrice','pBig'].forEach(hookEarn);
  if(ME) post('/coins/state').then(function(r){
    if(r&&r.ok){ S.bal=r.bal; S.worth=r.worth; S.loaded=true;
      if(r.open){ post('/coins/cancel'); try{ fetch('/discount/CLEAR',{credentials:'same-origin'}).catch(function(){}); }catch(e){} } }
    paintAll(); });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',mount); else mount();
})();
